<div class="dialog-header">
	<div class="header-title">
		<span style="font-size: 120%;">
			QB Link
		</span>
	</div>

	<button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
		<mat-icon>clear</mat-icon>
	</button>
</div>


<div class="edit-block">

	<ng-container *ngIf="qbLoading">
		<lib-progress-spinner></lib-progress-spinner>
	</ng-container>

	<form #userEditForm="ngForm" *ngIf="!qbLoading">
		<div class="form-block">
			<div class="form-row">
				<p-listbox [options]="qbCustomers" [(ngModel)]="selectedQbCustomer" autocomplete="off" [filter]="true"
					filterMode="startsWith" [filterValue]="searchString" optionLabel="displayName"
					[ngModelOptions]="{standalone: true}" class="p-list-box-block">
					<p-header>
						Search Customer
					</p-header>
				</p-listbox>
			</div>
		</div>

		<div class="save-btn-block">
			<button mat-button class="save-btn" (click)="linkQb()" [disabled]="!selectedQbCustomer || loadingSpinner"
				tabindex="1" type="submit" [ngClass]="{'disabled-button': !selectedQbCustomer || loadingSpinner}">
				<span *ngIf="!loadingSpinner">Link</span>
				<lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
			</button>
		</div>
	</form>

</div>